export default __webpack_public_path__ + "dd1031b911d33ac57630f69a137f65fa.png";